import { makeStyles } from '@material-ui/core';

export default makeStyles(({ spacing, palette }: any) => {
  const menuNavigation = palette.menuNavigation || {};

  return {
    tab: {
      height: spacing(9),
      backgroundColor: menuNavigation.mainCategoryBackground || palette.secondary.lightMain,
      borderRadius: '4px',
    },
    selectedCategory: {
      backgroundColor: menuNavigation.mainCategorySelectedBackground || palette.primary.main,
      color: menuNavigation.mainCategorySelectedText || palette.common.white,
    },
    categoriesContainer: {
      boxShadow: `inset 0px -2px 0px ${palette.action.activeOption}`,
      background: palette.background.default,
      display: 'flex',
      alignItems: 'center',
      height: spacing(13),
    },
    tabsContainer: {
      paddingLeft: spacing(5),
    },
    tabElement: {
      display: 'flex',
      flexDirection: 'row',
      height: '100%',
    },
    tabLabelIcon: {
      minHeight: spacing(9),
      height: spacing(9),
      '&:first-child': {
        marginLeft: spacing(5),
      },
      marginRight: spacing(5),
      paddingTop: spacing(1.5),
    },
    icon: {
      marginTop: spacing(1),
      marginRight: spacing(1.5),
    },
  };
});
